module.exports = __webpack_public_path__ + "static/img/materialsax05.591f8f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsax05.png
// module id = Ppwg
// module chunks = 2